var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"accordion box",attrs:{"role":"presentation"}},_vm._l((_vm.content),function(item){return _c('accordion-item-foreign',{key:item.id,attrs:{"item":item,"dataItem":_vm.dataItem}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }